import React, { useContext, useEffect, useState } from 'react';

import { StyleSheet, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function Indicator({
  meeting,
  iconPack = defaultIconPack,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size = 'sm',
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const [op, setOp] = useState(1.0);
  useEffect(() => {
    const interval = setInterval(() => {
      if (op < 2) setOp(op + 0.05);
      else setOp(0);
    }, 50);
    return () => clearInterval(interval);
  }, [op]);
  const styles = StyleSheet.create({
    container: {
      flexDirection: 'row',
      marginTop: 3,
      marginLeft: 8,
      opacity: Math.abs(op - 1),
    },
  });
  if (meeting.recording.recordingState === 'RECORDING')
    return (
      <View style={styles.container}>
        <SvgXml
          xml={iconPack.recording.replace('currentColor', colors.danger)}
          width={18}
          height={18}
        />
        <DyteText> {t('recording.label')}</DyteText>
      </View>
    );
  else return <View />;
}
